// Shared CRUD helpers for the group admin list views (ModelQuickGroup,
// ModelQuickReply, SetupGroupModel, ShortcutMenu, GroupPromptTemplate),
// extracted to remove duplicated code (SonarQube "Duplicated Lines")
// WITHOUT changing behavior.
//
// - fetchServerTable/buildServerTableQuery/applyServerTableResponse cover the
//   byte-identical server-table fetch skeleton (sort extraction, request temp
//   object, menus/searchTotalTable/totalTable bookkeeping). Each view keeps its
//   own Get()/GetDefault() wrapper that reproduces its exact loading-flag
//   sequencing via onSuccess/onError tails.
// - GetDDGPTModel/DeleteGroup/cancelDelete/View/showWarningToast were
//   byte-identical copies across the views (ShortcutMenu keeps its own
//   divergent GetDDGPTModel, which overrides the mixin method).
//
// IMPORTANT: pass `callFn` as an arrow that invokes the API method on its own
// object (this.$call.X(...)) so the call object keeps its `this` binding.
export default {
  methods: {
    buildServerTableQuery(withSort = true) {
      const { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (withSort && sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      return {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
    },
    applyServerTableResponse(dataResponse) {
      if (dataResponse.status == 0) {
        this.searchTotalTable = dataResponse.data.total;
        this.menus = dataResponse.data.data;
        this.totalTable = this.isFirst
          ? dataResponse.data.total
          : this.totalTable;
      } else {
        this.menus = [];
        this.searchTotalTable = 0;
        this.totalTable = 0;
      }
    },
    fetchServerTable(callFn, { withSort = true, query = {}, onSuccess, onError } = {}) {
      callFn(
        { ...this.buildServerTableQuery(withSort), ...query },
        (dataResponse) => {
          this.applyServerTableResponse(dataResponse);
          if (onSuccess) onSuccess(dataResponse);
        },
        (errorResource) => {
          if (onError) onError(errorResource);
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      this.loadingTable = true;
      this.$call.DDGPTModelIsPublish(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGPTModel = dataResponse.data;
          } else {
            this.DDGPTModel = [];
          }
          this.loadingTable = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      this.deleteItem = id;
      this.dialog_delete = true;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    View(item) {
      const routeData = this.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    showWarningToast(message) {
      this.$swal.fire({
        icon: "warning",
        title: message,
        showConfirmButton: false,
        timer: 2000,
      });
    },
  },
};
